/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function packaging(instance) {
	return {
		/**
		 * @param {number} packagingId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (packagingId, config = {}) => {
			return instance.get(`packaging/${packagingId}`, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`packaging${params}`, config)
		},

		/**
		 * @param {number} packagingId
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		edit: (packagingId, body, config = {}) => {
			return instance.put(`packaging/${packagingId}`, body, config)
		},

		/**
		 * @param {number} packagingId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (packagingId, config = {}) => {
			return instance.delete(`packaging/${packagingId}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('packaging', body, config)
		}
	}
}
